import * as Colors from './colors';

export const GrayThinBorder = `1px solid ${Colors.DividersAndCardBorders}`;
export const HoverBarder = `1px solid ${Colors.HoverBorder}`;
